import React, { FC } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './LastChanged.translations.json';
import { Entity } from '../queryClient';
import { DATE_TIME_FORMAT_EXTRA_SPACE, getDayjs } from '../utils';
import { TextLabel, TextLabelProps } from './TextLabel';

const { addTranslations, useTranslation } = i18nNsFactory('last-changed');
addTranslations(translations);

export type ModificationFields = Pick<Entity, 'modifiedAt' | 'modifiedBy'>;
export type LastChangedEntityProps = {
  entity?: ModificationFields;
} & Pick<TextLabelProps, 'htmlTag' | 'ellipsis'>;

export type LastChangedProps = {
  lastChangedAt?: string | null; // datetime
  lastChangedBy?: string | null;
} & Pick<TextLabelProps, 'htmlTag' | 'ellipsis'>;

export const LastChangedEntity: FC<LastChangedEntityProps> = (props) => {
  const { entity, ...rest } = props;

  if (!entity) {
    return null;
  }

  return (
    <LastChanged
      {...rest}
      lastChangedAt={entity.modifiedAt}
      lastChangedBy={entity.modifiedBy?.username}
    />
  );
};

export const LastChanged: FC<LastChangedProps> = (props) => {
  const { lastChangedAt, lastChangedBy, ellipsis, htmlTag } = props;
  const { t } = useTranslation();

  if (!lastChangedAt && !lastChangedBy) {
    return null;
  }

  const modifiedAt =
    lastChangedAt &&
    getDayjs(lastChangedAt)!.format(DATE_TIME_FORMAT_EXTRA_SPACE);
  const value = lastChangedBy
    ? t('last-changed-by-user', {
        modifiedAt,
        lastChangedBy: lastChangedBy,
      })
    : t('last-changed-by-unknown', { modifiedAt });

  return <TextLabel value={value} ellipsis={ellipsis} htmlTag={htmlTag} />;
};
